// src/utils/migrateData.ts
import { secureSetItem, secureGetItem } from './encryption';

export const migrateToEncryptedStorage = () => {
  const keys = ['userdata', 'useR_ID', 'devID', 'devName'];
  
  keys.forEach(key => {
    const data = localStorage.getItem(key);
    if (data) {
      try {
        // Try to parse as JSON (if it's plain text)
        const parsedData = JSON.parse(data);
        // If successful, encrypt and store
        secureSetItem(key, parsedData);
        // Optional: remove the plain text version
        // localStorage.removeItem(key);
      } catch (e) {
        // Already encrypted or invalid JSON, do nothing
      }
    }
  });
};

// Call this in your App.tsx or index.tsx